// extracted by mini-css-extract-plugin
module.exports = {"searchDropdown":"styles_searchDropdown__FryBv","searchResults":"styles_searchResults__HEeR_","textPrimary":"styles_textPrimary__0O4Pe"};